<template>
<div v-if="reporte.banqueo[0][0]" class="font-weight-bold d-flex text-center line-height-1 text-caption w-100">
    <v-card outlined class="mr-1 pa-1 flex-grow-1" :class="{ 'accent--text': reporte.banqueo[0][1] >= 0, 'error--text': reporte.banqueo[0][1] < 0} ">
        {{ reporte.banqueo[0][1] | currency(reporte.divisa_code) }} <br/> {{ reporte.banqueo[0][0] | percent }}
    </v-card>
    <v-card outlined class="pa-1 flex-grow-1" :class="{ 'accent--text': reporte.banqueo[0][1] >= 0, 'error--text': reporte.banqueo[0][1] < 0} ">
        {{ reporte.banqueo[1][1] | currency(reporte.divisa_code) }} <br/> {{ reporte.banqueo[1][0] | percent }}
    </v-card> 
</div>
<div v-else>
    <v-card outlined class="font-weight-bold text-center line-height-1 text-caption w-100 py-2">
        SIN BANQUEO
    </v-card>
</div>
</template>
<script>

export default {
    props: {
        reporte: {
            required: true
        }
    }
}
</script>